import React from 'react';
import styles from './Contact.module.scss';
import InfoBox from './InfoBox';
import { FaMapLocationDot } from 'react-icons/fa6';
import { BiMailSend } from 'react-icons/bi';
const Contact = () => {
    return (
        <section id="contact" className={styles.contact}>
            <div className={styles.container}>
                <h3 className={styles['section-title']}>Contact me</h3>
                <h2 className={styles['section-text']}>Don't be shy, get in touch!</h2>
                <div className={styles.infos}>
                    <InfoBox title="Location" text="Dublin, Ireland"><FaMapLocationDot /></InfoBox>
                    <InfoBox title="Mail" link="y" text="bergjr.andrade@gmail.com"><BiMailSend /></InfoBox>
                </div>
            </div>
        </section>
    );
}

export default Contact;
